import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconFlagId = createIcon({
  viewBox: '0 0 22 22',
  path: (
    <>
      <circle cx="10.8" cy="10.8" r="10.8" fill="white" />
      <path
        d="M0 10.8H21.6C21.6 16.7647 16.7647 21.6 10.8 21.6C4.83533 21.6 0 16.7647 0 10.8Z"
        fill="white"
      />
      <path
        d="M21.6001 10.8L9.91821e-05 10.8C9.97036e-05 4.83537 4.83543 4.81255e-05 10.8001 4.86469e-05C16.7648 4.91683e-05 21.6001 4.83537 21.6001 10.8Z"
        fill="#C8414B"
      />
    </>
  ),
});

export default IconFlagId;
